import { render } from "./CButtonRadio.vue?vue&type=template&id=2fd0c3f2&scoped=true&ts=true"
import script from "./CButtonRadio.vue?vue&type=script&lang=ts"
export * from "./CButtonRadio.vue?vue&type=script&lang=ts"

import "./CButtonRadio.vue?vue&type=style&index=0&id=2fd0c3f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd0c3f2"]])

export default __exports__